import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { incrementRouterSpaceReactKey } from '~src/app/actions/spaces/IncrementRouterSpaceReactKeyAction';
import { CreatedAtDetailSection } from '~src/app/content/contentDetailDialog/CommonContentDetailSections';
import { sectionContainer } from '~src/app/content/contentDetailDialog/ContentDetailSection';
import { ConnectedDeleteContentSection } from '~src/app/content/contentDetailDialog/DeleteContentSection';
import {
  DESCRIPTION_MAX_LENGTH,
  DescriptionDetailSection
} from '~src/app/content/contentDetailDialog/DescriptionDetailSection';
import { ConnectedOwnerDetailSection } from '~src/app/content/contentDetailDialog/OwnerDetailSection';
import { siteUrlsSelector } from '~src/app/selectors/SiteUrlsSelectors';
import { AppState } from '~src/app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '~src/app/utils/ConnectUtils';
import { Messages } from '~src/codegen/Localize';
import { ChangeProjectDescriptionAction } from '~src/content/services/ChangeProjectDescriptionAction';
import { IProjectInfo } from '~src/ts/models/IProjectInfo';
import { IProjectActions } from '~src/ts/ServerApi/types/IProjectActions';

import { SpacesSiteUrls } from '../SpacesSiteUrls';


interface ProjectDetailsDialogBodyOwnProps {
  readonly project: IProjectInfo;
  readonly allowedActions: IProjectActions;
}

interface ProjectDetailsDialogBodyStateProps {
  readonly urls: SpacesSiteUrls;
}

interface ProjectDetailsDialogBodyDispatchProps {
  readonly incrementRouterSpaceReactKey: () => void;
}

type ProjectDetailsDialogBodyProps =
    ProjectDetailsDialogBodyOwnProps &
    ProjectDetailsDialogBodyStateProps &
    ProjectDetailsDialogBodyDispatchProps;

export function ProjectDetailsDialogBody(props: ProjectDetailsDialogBodyProps): JSX.Element {

  const setDescription = React.useCallback((description: string) => {
    return ChangeProjectDescriptionAction.execute(props.project, description);
  }, [props.project]);


  function allowedAction(actionName: keyof IProjectActions): boolean {
    return !!(props.allowedActions?.[actionName]);
  }

  return (
    <div className={sectionContainer}>
      <DescriptionDetailSection
        description={props.project.description}
        isActionEnabled={allowedAction('setDescription')}
        setDescription={setDescription}
        descriptionMaxLength={DESCRIPTION_MAX_LENGTH}
        showPreviewAndFormattingHints={true}
        showProjectImageHint={true}
        incrementRouterSpaceReactKey={props.incrementRouterSpaceReactKey}
      />
      <ConnectedOwnerDetailSection content={props.project} isActionEnabled={allowedAction('setOwner')} urls={props.urls}/>
      <CreatedAtDetailSection date={props.project.createdAt} />
      {allowedAction('del') &&
        <ConnectedDeleteContentSection
          actionMessage={Messages.deleteProject_action()}
          content={props.project}
        />
      }
    </div>
  );
}

const mapDispatchToProps: MapDispatchToProps<ProjectDetailsDialogBodyDispatchProps> = (dispatch) => bindActionCreators({
  incrementRouterSpaceReactKey: incrementRouterSpaceReactKey
}, dispatch);

const mapStateToProps: MapStateToProps<ProjectDetailsDialogBodyStateProps> = (state: AppState, ownProps: ProjectDetailsDialogBodyOwnProps) => ({
  urls: siteUrlsSelector(state),
});

export const ConnectedProjectDetailsDialogBody: React.ComponentClass<ProjectDetailsDialogBodyOwnProps> =
  connect(mapStateToProps, mapDispatchToProps)(ProjectDetailsDialogBody);
